import React, { Component } from 'react';
import { XMLParser } from 'fast-xml-parser';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import importWhiteIcon from '../../../common/Images/import_file_white.png';
import { RELYING_PARTIES_TYPES } from '@silverfort-nodelibs/common/utils/consts';

function readFileAsync(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = async () => {
            const parser = new XMLParser({
                ignoreAttributes: false,
                attributeNamePrefix: '@_'
            });
            const connectionData = parser.parse(reader.result);
            const entityID = connectionData['md:EntityDescriptor']['@_entityID'];
            if (!entityID) {
                console.log('File without entityID');
                resolve();
                return;
            }
            const relyingParty = {
                name: connectionData['md:EntityDescriptor']['@_urn:name'] || entityID,
                identifiers: entityID.replace(/ /g, ':')
            };
            resolve(relyingParty);
        };

        reader.onerror = reject;

        reader.readAsText(file);
    });
}

class ImportPingFedRelyingParties extends Component {
    state = {
        loading: false,
        selectedFiles: null,
        directoryPath: '',
        error: null
    };

    directoryChangedHandler = (files) => {
        let directoryPath = '';
        if (files && files.length > 0 && files[0].webkitRelativePath) {
            try {
                directoryPath = files[0].webkitRelativePath.split('/')[0];
            } catch (err) {
                console.error(err);
            }
        }

        this.setState({ selectedFiles: files, directoryPath: directoryPath, error: null, loading: false });
    };

    importClickedHandler = async () => {
        this.setState({ error: null, loading: true });
        const importedRelyingParties = [];
        for (const file of Array.from(this.state.selectedFiles)) {
            if (file.name.endsWith('.xml')) {
                const pingFedRelyingParty = await readFileAsync(file);

                if (pingFedRelyingParty) {
                    importedRelyingParties.push(pingFedRelyingParty);
                } else {
                    console.log('File not imported: ' + JSON.stringify(file));
                }
            }
        }
        this.props.save(importedRelyingParties);
        this.props.close();
    };

    render() {
        return (
            <Modal
                id="importSilverfortConfigurationConfirm"
                dialogClassName="modal-md"
                show
                onHide={this.props.close}
                keyboard={false}
                backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{`Import Apps federated via ${RELYING_PARTIES_TYPES.PING_FED.DISPLAY}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="content">
                        <div className="title">Select directory to import:</div>
                        <div className="fileSelector">
                            <div className="filePath">
                                <span>{this.state.directoryPath}</span>
                            </div>
                            <div className="importButton directory">
                                <label htmlFor="configurationImport">
                                    <img src={importWhiteIcon} alt="" />
                                    Choose Directory
                                </label>
                                <input
                                    type="file"
                                    id="configurationImport"
                                    accept="application/text"
                                    directory=""
                                    webkitdirectory=""
                                    multiple={false}
                                    disabled={this.state.loading}
                                    onChange={(e) => this.directoryChangedHandler(e.target.files)}
                                />
                            </div>
                        </div>
                        {this.state.error && (
                            <div className="error">
                                <span>{this.state.error}</span>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button onClick={this.props.close}>Cancel</Button>
                        <Button
                            bsStyle={'danger'}
                            disabled={!this.state.selectedFiles || this.state.loading}
                            onClick={this.importClickedHandler}>
                            Import
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ImportPingFedRelyingParties;
